'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getSurroundingLoc = require('./getSurroundingLoc');

var _getSurroundingLoc2 = _interopRequireDefault(_getSurroundingLoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Alter the location information of a node so that it surrounds a list of
// other nodes.
exports.default = function placeAroundNodes(newNode) {
  for (var _len = arguments.length, nodes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    nodes[_key - 1] = arguments[_key];
  }

  return Object.assign(newNode, (0, _getSurroundingLoc2.default)(nodes));
};


//////////////////
// WEBPACK FOOTER
// ../~/ast-loc-utils/lib/placeAroundNodes.js
// module id = 988
// module chunks = 0